import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _defineProperty from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
/**
 * 布局组件
 */
import { Container, Header, Main, Footer, Aside } from 'element-ui';
var Components = {
  north: Header,
  default: Main,
  south: Footer,
  east: Aside,
  west: Aside
};

/**
 * 插槽
 * @property {string} default 默认插槽, 定义主体内容
 * @property {string} north 定义内容头部区域
 * @property {string} south 定义内容脚部区域
 * @property {string} west 定义内容左部连载
 * @property {string} east 定义内容右部连载
 */
export default {
  name: 'MyLayout',
  components: {
    Container: Container,
    Header: Header,
    Main: Main,
    Footer: Footer,
    Aside: Aside
  },
  /**
   * 属性参数
   *
   * @property {boolean} [fit] 适配父容器
   * @property {boolean} [border] 是否显示边框
   * @property {boolean} [split] 各区域之间显示分隔
   * @property {string} [direction] 排列方向，默认自动判断，也可以指定，可选值：'vertical', 'horizontal'
   * @property {Object} [north] 区域
   * @property {string|number} [north.height] 区域高度
   * @property {Object} [south] 区域
   * @property {string|number} [south.height] 区域高度
   * @property {Object} [west] 区域
   * @property {string|number} [west.height] 区域高度
   * @property {Object} [east] 区域
   * @property {string|number} [east.height] 区域高度
   */
  props: {
    // 适配父容器
    fit: Boolean,
    // 显示边框
    border: Boolean,
    // 分隔
    split: Boolean,
    // 排列方向
    direction: {
      type: String,
      validator: function validator(val) {
        return ['vertical', 'horizontal'].includes(val);
      },
      default: function _default() {
        return 'vertical';
      }
    },
    north: {
      type: Object,
      default: function _default() {}
    },
    south: {
      type: Object,
      default: function _default() {}
    },
    west: {
      type: Object,
      default: function _default() {}
    },
    east: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    classes: function classes() {
      return _defineProperty({
        'my-layout': true,
        'is-fit': this.fit,
        'is-border': this.border,
        'is-split': this.split
      }, "is-".concat(this.direction), !!this.direction);
    }
  },
  methods: {
    getDirection: function getDirection() {
      if (this.direction) return this.direction;
      var _this$$slots = this.$slots,
        north = _this$$slots.north,
        south = _this$$slots.south,
        west = _this$$slots.west,
        east = _this$$slots.east;
      var isVertical = !west && !east;
      var isHorizontal = !north && !south;
      return isVertical || !isVertical && !isHorizontal ? 'vertical' : 'horizontal';
    },
    getRegionOptions: function getRegionOptions(type) {
      return _objectSpread({}, this[type] || {});
    },
    regionRender: function regionRender(type) {
      var h = this.$createElement;
      if (!this.$slots[type]) return;
      var options = this.getRegionOptions(type);
      var attrs = {
        north: 'height',
        south: 'height',
        west: 'width',
        east: 'width'
      };
      var defaultValues = {
        north: 60,
        south: 60,
        west: 256,
        east: 256
      };
      var name = attrs[type];
      var size = Number.parseInt(options[name] === undefined ? defaultValues[type] : options[name]);
      return this.$createElement(Components[type], {
        class: ['my-layout__region', "my-layout__".concat(type), {
          'is-split': this.split,
          'is-border': this.border
        }],
        style: _defineProperty({}, name, typeof size === 'number' ? "".concat(size, "px") : size)
      }, this.fit && size ? [h("div", {
        "class": 'my-layout__fit'
      }, [this.$slots[type]])] : this.$slots[type]);
    }
  },
  render: function render() {
    var _this = this;
    var h = arguments[0];
    var _this$$slots2 = this.$slots,
      north = _this$$slots2.north,
      south = _this$$slots2.south,
      west = _this$$slots2.west,
      east = _this$$slots2.east;
    var direction = this.getDirection();
    var wrapHorizontal = function wrapHorizontal() {
      if (west || east) {
        return h(Container, {
          "class": 'my-layout__wrapper',
          "attrs": {
            "direction": 'horizontal'
          }
        }, [[_this.regionRender('west'), _this.regionRender('default'), _this.regionRender('east')]]);
      } else {
        return _this.regionRender('default');
      }
    };
    var wrapVertical = function wrapVertical() {
      if (north || south) {
        return h(Container, {
          "class": 'my-layout__wrapper',
          "attrs": {
            "direction": 'vertical'
          }
        }, [[_this.regionRender('north'), _this.regionRender('default'), _this.regionRender('south')]]);
      } else {
        return _this.regionRender('default');
      }
    };
    return h(Container, {
      "attrs": {
        "direction": direction
      },
      "class": this.classes
    }, [direction === 'vertical' ? [this.regionRender('north'), wrapHorizontal(), this.regionRender('south')] : [this.regionRender('west'), wrapVertical(), this.regionRender('east')]]);
  }
};